import type { FastifySchema } from 'fastify';
import z from 'zod';

export const urlSchema = z
  .string()
  .transform(val => {
    const url = new URL(val.includes('://') ? val : `https://${val}`);

    return url.href;
  })
  .refine(
    val => {
      try {
        const url = new URL(val);

        const isHttp = url.protocol === 'http:' || url.protocol === 'https:';

        // Basic domain validation: checks for at least one dot in the hostname
        // otherwise strings like 'kanbu' are taken as a valid URL, since JS URL structure
        // is very lenient
        const hasValidHostname = /^[\d.a-z-]+\.[a-z]{2,}$/i.test(url.hostname);

        return isHttp && hasValidHostname;
      } catch {
        return false;
      }
    },
    {
      message: 'Invalid URL',
    },
  );

export type EndpointContract = {
  path: string;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  schema: FastifySchema;
};

export type EndpointContractGroup = Record<
  string,
  EndpointContract | Record<string, EndpointContract>
>;
